<div mat-dialog-title>Add Recurring Document</div>
<div mat-dialog-content>
  <form>
    <div class="row gutters">
      <mat-form-field class="col-4">
        <mat-label>Entity Type</mat-label>
        <mat-select [formControl]="formControls.controls.entity_type" required>
          <mat-option value="Project">Project</mat-option>
          <mat-option value="Fund">Fund</mat-option>
          <mat-option value="MTE">Middle-Tier Entity</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-8">
        <mat-label>Entity</mat-label>
        <input
          type="text"
          matInput
          [matAutocomplete]="auto"
          [formControl]="formControls.controls.entity_name"
          [disabled]="
            (formControls.controls.entity_type.valueChanges | async) === null
          "
          required />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          @for (entityMap of documentDialogService.entities$ | async; track entityMap) {
            <mat-option
              [value]="entityMap"
              >{{
              entityMap.owned_entity_name?.length
              ? entityMap.owned_entity_name
              : "Unknown Entity"
              }}{{
              entityMap.related_name?.length
              ? " [" + entityMap.related_name + "]"
              : ""
              }}</mat-option
              >
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="row gutters">
        <mat-form-field class="col-6">
          <mat-label> Audit Inclusion </mat-label>
          <mat-select [formControl]="formControls.controls.audit_requirement">
            <mat-option [value]="true">Include</mat-option>
            <mat-option [value]="false">Exclude</mat-option>
            <mat-option [value]="null">Exclude Permanently</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label> Tax Return Inclusion </mat-label>
          <mat-select [formControl]="formControls.controls.audit_requirement">
            <mat-option [value]="true">Include</mat-option>
            <mat-option [value]="false">Exclude</mat-option>
            <mat-option [value]="null">Exclude Permanently</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row gutters"><h3>Default Due Dates</h3></div>
      <div class="row gutters">
        <div class="form-group col-6">
          <span class="title">Audit</span>
          <mat-form-field>
            <mat-label> Draft </mat-label>
            <input
              matInput
              [matDatepicker]="auditDraft"
              [formControl]="formControls.controls.audit_draft_due" />
            <mat-datepicker-toggle
              matIconSuffix
            [for]="auditDraft"></mat-datepicker-toggle>
            <mat-datepicker #auditDraft></mat-datepicker>

            <mat-hint>MM/DD/YYYY</mat-hint>
          </mat-form-field>
          <mat-form-field>
            <mat-label> Final </mat-label>
            <input
              matInput
              [matDatepicker]="auditFinal"
              [formControl]="formControls.controls.audit_final_due" />
            <mat-datepicker-toggle
              matIconSuffix
            [for]="auditFinal"></mat-datepicker-toggle>
            <mat-datepicker #auditFinal></mat-datepicker>
            <mat-hint>MM/DD/YYYY</mat-hint>
          </mat-form-field>
        </div>
        <div class="form-group col-6">
          <span class="title">Tax Return</span>
          <mat-form-field>
            <mat-label> Draft </mat-label>
            <input
              matInput
              [matDatepicker]="returnDraft"
              [formControl]="formControls.controls.return_draft_due" />
            <mat-datepicker-toggle
              matIconSuffix
            [for]="returnDraft"></mat-datepicker-toggle>
            <mat-datepicker #returnDraft></mat-datepicker>
            <mat-hint>MM/DD/YYYY</mat-hint>
          </mat-form-field>
          <mat-form-field>
            <mat-label> Final </mat-label>
            <input
              matInput
              [matDatepicker]="returnFinal"
              [formControl]="formControls.controls.return_final_due" />
            <mat-datepicker-toggle
              matIconSuffix
            [for]="returnFinal"></mat-datepicker-toggle>
            <mat-datepicker #returnFinal></mat-datepicker>
            <mat-hint>MM/DD/YYYY</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="saveRequirements()">Save</button>
    <button mat-raised-button (click)="dialogRef.close()">Cancel</button>
  </div>
